import type { RpcSysParams } from '@platform/store/user';
import type { RpcFilters } from '@platform/shared/rpc/node/rpc-helpers';
import { sqlFilterAnyProperty } from '@platform/shared/rpc/node/rpc-helpers';
import type { LegacyOptions } from '@platform/shared/rpc/node/rpc-wrapper';
import RpcWrapper from '@platform/shared/rpc/node/rpc-wrapper';

type DoRpcLegacyParams = {
    sysParams: Omit<RpcSysParams, 'currExtUserId'> & { currExtUserId?: number | string | null };
    schemaName: string;
    page?: number | [page: number, pageSize?: number];
    tableName: string;
    sqlFilter?: string | RpcFilters;
    tableStructure?: any[];
    data?: any[];
    _legacyJson?: boolean;
};

const legacy: LegacyOptions = {
    dateAsEpoch: false,
    timestampAsEpoch: true,
    alwaysPopulateRefs: false,
};

export async function doRpcLegacy(type: string, data: DoRpcLegacyParams): Promise<any | typeof NaN> {
    if (type === 'read' && data.schemaName && data.tableName) {
        const sqlFilters = sqlFilterAnyProperty(data.sqlFilter);
        const isProcedure = /^(\w+)\((.*)\)$/.exec(data.tableName);
        let result = null;
        if (isProcedure) {
            result = await RpcWrapper.callFunction(
                {
                    fn: data.schemaName + '.' + isProcedure[1],
                    args: isProcedure[2],
                    struct: data.tableStructure as any,
                    options: {
                        legacy: { ...legacy, doNotParseJson: data?._legacyJson || false },
                        filters: sqlFilters,
                    },
                }
                //{ baseURL: 'http://localhost:3000' }
            );
        } else {
            result = await RpcWrapper.readWithRefs(
                data.tableStructure
                    ? {
                          tableInfo: { tableName: data.tableName, schemaName: data.schemaName },
                          struct: data.tableStructure as any,
                      }
                    : `${data.schemaName}.${data.tableName}`,
                {
                    legacy: { ...legacy, doNotParseJson: data?._legacyJson || false },
                    forceReadStructureFromDB: true,
                    filters: sqlFilters,
                    page: data?.page,
                }
                //{ baseURL: 'http://localhost:3000' }
            );
        }

        return { data: result, success: true };
    } else if (type === 'modify' && data.data && !data.tableStructure && !data.sqlFilter) {
        const result = await RpcWrapper.modify(
            `${data.schemaName || 'pusk'}.${data.tableName}`,
            data.data,
            {
                legacy: true,
                allowUndefined: true,
                forceReadStructureFromDB: true,
            }
            //{ baseURL: 'http://localhost:3000' }
        );
        return { data: result, success: true };
    } else if (type === 'delete') {
        await RpcWrapper.markAsDeleted(
            {
                tableName: data.tableName,
                schemaName: data.schemaName,
            },
            data.data?.map((item) => item.id) ?? []
        );
        return { success: true };
    }

    console.warn('[RPC Legacy] Omit. ', `type=${type}`, `${data.schemaName}.${data.tableName}`, data);

    return NaN;
}
